"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));
var _react = _interopRequireWildcard(require("react"));
var _DateTHead = _interopRequireDefault(require("./DateTHead"));
var _DateTBody = _interopRequireDefault(require("./DateTBody"));
var DateTable = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(DateTable, _Component);
  var _super = (0, _createSuper2["default"])(DateTable);
  function DateTable() {
    (0, _classCallCheck2["default"])(this, DateTable);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(DateTable, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var prefixCls = props.prefixCls;
      return /*#__PURE__*/_react["default"].createElement("table", {
        className: "".concat(prefixCls, "-table"),
        cellSpacing: "0",
        role: "grid"
      }, /*#__PURE__*/_react["default"].createElement(_DateTHead["default"], props), /*#__PURE__*/_react["default"].createElement(_DateTBody["default"], props));
    }
  }]);
  return DateTable;
}(_react.Component);
exports["default"] = DateTable;